"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoxyMarketService = exports.FOXY_ASSET_ID = void 0;
const types_1 = require("@shapeshiftoss/types");
const dayjs_1 = __importDefault(require("dayjs"));
const config_1 = require("../config");
const bignumber_1 = require("../utils/bignumber");
const isValidDate_1 = require("../utils/isValidDate");
const rateLimiters_1 = require("../utils/rateLimiters");
exports.FOXY_ASSET_ID = 'eip155:1/erc20:0xDc49108ce5C57bc3408c3A5E95F3d864eC386Ed3';
const FOX_COINCAP_ID = 'fox-token';
const axios = (0, rateLimiters_1.rateLimitedAxios)(config_1.RATE_LIMIT_THRESHOLDS_PER_MINUTE.COINCAP);
class FoxyMarketService {
    constructor() {
        this.baseUrl = 'https://api.coincap.io/v2';
        this.findAll = async () => {
            try {
                const assetId = exports.FOXY_ASSET_ID;
                const marketData = await this.findByAssetId({ assetId });
                return { [assetId]: marketData };
            }
            catch (e) {
                console.warn(e);
                return {};
            }
        };
        this.findByAssetId = async ({ assetId }) => {
            try {
                if (assetId.toLowerCase() !== exports.FOXY_ASSET_ID.toLowerCase()) {
                    console.warn('FoxyMarketService(findByAssetId): Failed to find by AssetId');
                    return null;
                }
                const { data } = await axios.get(`${this.baseUrl}/assets/${FOX_COINCAP_ID}`);
                const marketData = data.data;
                return {
                    price: marketData.priceUsd,
                    marketCap: '0',
                    changePercent24Hr: parseFloat(marketData.changePercent24Hr),
                    volume: '0' // TODO: add volume once able to get foxy volume data
                };
            }
            catch (e) {
                console.warn(e);
                throw new Error('FoxyMarketService(findByAssetId): error fetching market data');
            }
        };
        this.findPriceHistoryByAssetId = async ({ assetId, timeframe }) => {
            if (assetId.toLowerCase() !== exports.FOXY_ASSET_ID.toLowerCase()) {
                console.warn('FoxyMarketService(findPriceHistoryByAssetId): Failed to find price history by AssetId');
                return [];
            }
            const end = (0, dayjs_1.default)().startOf('minute');
            let start;
            let interval;
            switch (timeframe) {
                case types_1.HistoryTimeframe.HOUR:
                    start = end.subtract(1, 'hour');
                    interval = 'm5';
                    break;
                case types_1.HistoryTimeframe.DAY:
                    start = end.subtract(1, 'day');
                    interval = 'h1';
                    break;
                case types_1.HistoryTimeframe.WEEK:
                    start = end.subtract(1, 'week');
                    interval = 'd1';
                    break;
                case types_1.HistoryTimeframe.MONTH:
                    start = end.subtract(1, 'month');
                    interval = 'd1';
                    break;
                case types_1.HistoryTimeframe.YEAR:
                    start = end.subtract(1, 'year');
                    interval = 'd1';
                    break;
                case types_1.HistoryTimeframe.ALL:
                    start = end.subtract(20, 'years');
                    interval = 'd1';
                    break;
                default:
                    start = end;
            }
            try {
                const from = start.valueOf();
                const to = end.valueOf();
                const url = `${this.baseUrl}/assets/${FOX_COINCAP_ID}/history`;
                const { data: { data: coincapData } } = await axios.get(`${url}?id=${FOX_COINCAP_ID}&start=${from}&end=${to}&interval=${interval}`);
                return coincapData.reduce((acc, current) => {
                    const date = current.time;
                    if (!(0, isValidDate_1.isValidDate)(date)) {
                        console.error('FOXy asset history data has invalid date');
                        return acc;
                    }
                    const price = (0, bignumber_1.bn)(current.priceUsd);
                    if (price.isNaN()) {
                        console.error('FOXy asset history data has invalid price');
                        return acc;
                    }
                    acc.push({
                        date,
                        price: price.toNumber()
                    });
                    return acc;
                }, []);
            }
            catch (e) {
                console.warn(e);
                throw new Error('FoxyMarketService(findPriceHistoryByAssetId): error fetching price history');
            }
        };
    }
}
exports.FoxyMarketService = FoxyMarketService;
